export default __webpack_public_path__ + "9dea764c60b10eb621421c2e1113c047.png";